import { Component, HostBinding, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MatIconRegistry } from '@angular/material/icon';
import { DomSanitizer } from '@angular/platform-browser';
import { ModalTitleIcons } from '../../enums/modal-title-icons.enum';
import type { ModalData } from '../../interfaces/modal-data.interface';
import type { ModalActions } from '../../types/modal-actions.type';

const ICONS_NAMES = new Map<string, string>([
    [ModalTitleIcons.SUCCESS, 'aumico-pattern-icon-check-circle-outline'],
    [ModalTitleIcons.WARNING, 'aumico-pattern-icon-alert-triangle'],
    [ModalTitleIcons.INFO, 'aumico-pattern-icon-info'],
]);
@Component({
    selector: 'app-modal',
    templateUrl: './modal.component.html',
    styleUrls: ['./modal.component.scss'],
})
export class ModalComponent implements OnInit {
    titleIcon: string | undefined;
    backgroundColor: string | undefined;

    @HostBinding('style.--dynamic-width') dynamicWidth = undefined;
    @HostBinding('style.--dynamic-height') dynamicHeight = undefined;
    @HostBinding('style.--text-size') textSize = undefined;
    @HostBinding('style.--footer-background-color') footerBackgroundColor = undefined;

    constructor(
        private readonly matIconRegistry: MatIconRegistry,
        private readonly domSanitizer: DomSanitizer,
        @Inject(MAT_DIALOG_DATA) public data: ModalData,
        private readonly dialogRef: MatDialogRef<ModalComponent, ModalActions>,
    ) {
        if (this.data.titleIcon !== ModalTitleIcons.DEFAULT) {
            const icon = ICONS_NAMES.get(this.data.titleIcon);
            if (icon != null) {
                this.addSvgIcon(this.data.titleIcon, icon);
            }
        }
        if (this.data.content.icon != null) {
            this.addSvgIcon(this.data.content.icon, this.data.content.icon);
        }

        if (this.data.backgroundColor != null) {
            this.backgroundColor = this.data.backgroundColor;
        }

        if (this.data.width != null) {
            this.dynamicWidth = this.data.width;
        }

        if (this.data.minHeight != null) {
            this.dynamicHeight = this.data.minHeight;
        }

        if (this.data.textSize != null) {
            this.textSize = this.data.textSize;
        }

        if (this.data.footerBackgroundColor != null) {
            this.footerBackgroundColor = this.data.footerBackgroundColor;
        }
    }

    ngOnInit(): void {
        this.titleIcon = ICONS_NAMES.get(this.data.titleIcon);
    }

    private addSvgIcon(name: string, icon: string): void {
        this.matIconRegistry.addSvgIcon(
            name,
            this.domSanitizer.bypassSecurityTrustResourceUrl(`/assets/icons/${icon}.svg`),
        );
    }

    onClose(): void {
        this.dialogRef.close();
    }

    onAction(action: ModalActions): void {
        this.dialogRef.close(action);
    }
}
